import axios from 'axios'
import { loadingService } from '@/utils/loadingService'
import { toastService } from '@/utils/toastService'
import i18n from '@/i18n'
import store from '@/store'
import { localeToRegionIdMap, uniteTenementId, errorCodeMap } from '@/config/const'

const resolveErrorNs = (path) => {
  if (path.includes('halloween')) return 'halloween'
  if (path.includes('ann2026')) return 'ann2026'
  if (path.includes('monopoly')) return 'monopoly'
  return 'wc2026'
}

const makeErrorMessage = (errorCode) => {
  const mapped = errorCodeMap[errorCode]
  if (mapped) return i18n.global.t(mapped)
  const path = typeof location !== 'undefined' ? location.pathname : ''
  const ns = resolveErrorNs(path)
  const key = `${ns}.error.code${errorCode}`
  const msg = i18n.global.t(key)
  if (msg !== key) return msg
  // 登录/账号服等共用错误码回退到 wc2026
  const fallbackKey = `wc2026.error.code${errorCode}`
  const fallbackMsg = i18n.global.t(fallbackKey)
  if (fallbackMsg !== fallbackKey) return fallbackMsg
  return i18n.global.t('api.serverError') + errorCode
}

const clearActUserInfo = () => {
  store.commit('SET_ACT_USER_INFO', {})
}

const showNetworkError = () => {
  if (location.href.includes('wc20261')) {
    toastService.showSmall(i18n.global.t('api.networkError'))
  } else {
    toastService.show(i18n.global.t('api.networkError'))
  }
}
// 开发环境使用代理路径，生产环境使用完整 URL
// const baseURL = process.env.VUE_APP_ENV === 'dev' 
//   ? '/actApi'  // 开发环境：走代理
//   : process.env.VUE_APP_ACT_URL
const instance = axios.create({
  // baseURL: baseURL,
})

instance.interceptors.request.use(config => {
  const locale = store.state.locale
  const { method, data = {}, params = {}, headers = {} } = config
  const mwrToken = store.state.actUserInfo.token
  if (mwrToken) {
    headers.Authorization = `Bearer ${mwrToken}`
  }
  const baseParams = {
    regionId: localeToRegionIdMap[locale],
    uniteTenementId
  }
  console.log(baseParams, 'baseParams')
  if (method === 'post') {
    const mergeParams = {
      ...baseParams,
      ...data
    }
    config.data = mergeParams
  } else if (method === 'get') {
    const mergeParams = {
      ...baseParams,
      ...params
    }
    config.params = mergeParams
  }
  let hasLoading = true
  if (config?.data?._loading === 0 || config?.params?._loading === 0) {
    hasLoading = false
  }
  if (hasLoading) {
    loadingService.show()
  }
  return config
}, error => {

    toastService.show('request error')
  
  loadingService.hide()
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  let hasLoading = true
  if (response.config.method === 'get' && response.config.params?._loading === 0) {
    hasLoading = false
  } else if (response.config.method === 'post' && response.config.data?._loading === 0) {
    hasLoading = false
  }
  if (hasLoading) {
    loadingService.hide()
  }
  if (response.status === 200) {
    if (response.data.code === 0) {
      return response.data.data
    } else {
      if (response.data.code === 401) {
        clearActUserInfo()
      }
      if (location.href.includes('wc20261')) {
        toastService.showSmall(makeErrorMessage(response.data.code))
      } else {
        toastService.show(makeErrorMessage(response.data.code))
      }
      return Promise.reject(response.data)
    }
  } else {
    if (response.status === 401) {
      clearActUserInfo()
    }
    showNetworkError()
    return Promise.reject(response.data)
  }
}, error => {
  if (error.response?.status === 401) {
    clearActUserInfo()
  }
  showNetworkError()
  loadingService.hide()
  return Promise.reject(error)
})

export default instance
